import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import {
  getClientIncapacitated,
  getClientSegment,
  getLast4IdOnFile,
} from '../../reducers/personal-data/personal-data.reducer';

// TODO-Personal Info Refactor: Replace these selectors with the VGIMPersonalInfoClient slice equivalents
export const selectPersonalDataState = createSelector(
  fromFeature.getPersonalDataState,
  (state) => state,
);
export const selectClientSegment = createSelector(selectPersonalDataState, getClientSegment);

export const selectPersonalDataLoaded = createSelector(
  fromFeature.getPersonalDataState,
  (state) => state.loaded,
);
export const selectClientIncapacitated = createSelector(
  selectPersonalDataState,
  getClientIncapacitated,
);

// TODO-Personal Info Refactor: Replace these selectors with the VGIM SSN slice equivalents
export const selectLast4IdOnFile = createSelector(selectPersonalDataState, getLast4IdOnFile);

// Selects from the MFE Personal Info Client slice
export const selectMfePersonalInfoData = createSelector(
  fromFeature.getMfePersonalInfoClientState,
  (state) => state.personalInfo,
);

export const selectClientName = createSelector(selectMfePersonalInfoData, (personalInfo) =>
  [personalInfo.firstName, personalInfo.middleName, personalInfo.lastName]
    .filter(Boolean)
    .join(' '),
);
export const selectClientDateOfBirth = createSelector(selectMfePersonalInfoData, (personalInfo) =>
  personalInfo.birthDate ? personalInfo.birthDate : null,
);
export const selectClientEmailAddress = createSelector(
  selectMfePersonalInfoData,
  (personalInfo) => personalInfo.email,
);
export const selectClientFlagDigitalAdvise = createSelector(
  selectPersonalDataState,
  ({ digitalAdviseService }) => digitalAdviseService,
);

export const selectIsOrganizationUser = createSelector(
  selectPersonalDataState,
  (state) => state.isOrganizationUser ?? false,
);
